export default __webpack_public_path__ + "static/media/producto-15.142802ea.jpeg";